import { render, staticRenderFns } from "./DevicesCardDeviceTabbedForm.vue?vue&type=template&id=36b339da&scoped=true&"
import script from "./DevicesCardDeviceTabbedForm.vue?vue&type=script&lang=ts&"
export * from "./DevicesCardDeviceTabbedForm.vue?vue&type=script&lang=ts&"
import style0 from "./DevicesCardDeviceTabbedForm.vue?vue&type=style&index=0&id=36b339da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b339da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
